import { useEffect } from 'react';

import { authorizeAPI } from 'modules/auth/utils/authorizeAPI';
import { setIsAPIAuthorized } from 'modules/auth/store/authSlice';
import { useAppDispatch } from 'store/useAppDispatch';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { useSSOAuth } from 'modules/auth/hooks/useSSOAuth';

export const useInitAPI = () => {
  const { isSignedIn } = useSSOAuth();

  const { authToken } = useAuth();

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isSignedIn) {
      if (authToken) {
        authorizeAPI({ authToken });

        dispatch(setIsAPIAuthorized(true));
      }
    } else {
      dispatch(setIsAPIAuthorized(false));
    }
  }, [dispatch, authToken, isSignedIn]);
};
